module.exports = __webpack_public_path__ + "static/media/clippy2.d1db3d40.png";